import React from 'react';
import PropTypes from 'prop-types';
import { DescriptionListLabel, DescriptionListValue } from '../../atoms';
import { BoldText } from './styles.js';
import { getPlanFreeItems } from './functions';

export const PricingListDisplayFreeItems = ({
  plans,
  puptainerLabel,
  scooperLabel,
  bowlLabel,
}) => {
  const planFreeItems = getPlanFreeItems(plans);

  return (
    <>
      {planFreeItems.puptainerCount === 0 ? null : (
        <>
          <DescriptionListLabel color="hero.spinach">
            {puptainerLabel}{' '}
            {planFreeItems.puptainerCount > 1
              ? `X${planFreeItems.puptainerCount}`
              : null}
          </DescriptionListLabel>

          <DescriptionListValue>
            <BoldText color="hero.spinach">FREE</BoldText>
          </DescriptionListValue>
        </>
      )}
      {planFreeItems.scooperCount === 0 ? null : (
        <>
          <DescriptionListLabel color="hero.spinach">
            {scooperLabel}{' '}
            {planFreeItems.scooperCount > 1
              ? `X${planFreeItems.scooperCount}`
              : null}
          </DescriptionListLabel>

          <DescriptionListValue>
            <BoldText color="hero.spinach">FREE</BoldText>
          </DescriptionListValue>
        </>
      )}
      {planFreeItems.bowlCount === 0 ? null : (
        <>
          <DescriptionListLabel color="hero.spinach">
            {bowlLabel}{' '}
            {planFreeItems.bowlCount > 1 ? `X${planFreeItems.bowlCount}` : null}
          </DescriptionListLabel>

          <DescriptionListValue>
            <BoldText color="hero.spinach">FREE</BoldText>
          </DescriptionListValue>
        </>
      )}
    </>
  );
};

PricingListDisplayFreeItems.displayName = 'PricingListDisplayFreeItems';
PricingListDisplayFreeItems.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      breeds: PropTypes.arrayOf(PropTypes.string).isRequired,
      petId: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      priceWithDiscount: PropTypes.string.isRequired,
      recipes: PropTypes.object.isRequired,
      numPacks: PropTypes.number.isRequired,
      bagCount: PropTypes.number.isRequired,
      productType: PropTypes.string,
    }),
  ),
  puptainerLabel: PropTypes.string.isRequired,
  scooperLabel: PropTypes.string.isRequired,
  bowlLabel: PropTypes.string,
};
